export default "__VITE_ASSET__e91a9621__"